import { Box, Divider, Stack } from "@mui/material";
import Quill from "quill";
import ReactDOMServer from "react-dom/server";
import { useEffect } from "react";
import CustomIcon from "../../library/icon-library";

const quillIcons = Quill.import("ui/icons");

function QuillToolBar() {
  quillIcons["align"][""] = ReactDOMServer.renderToStaticMarkup(
    <CustomIcon icon="align_left" color="black" size="lg" />,
  );
  quillIcons["align"]["center"] = ReactDOMServer.renderToStaticMarkup(
    <CustomIcon icon="align_center" color="black" size="lg" />,
  );
  quillIcons["align"]["right"] = ReactDOMServer.renderToStaticMarkup(
    <CustomIcon icon="align_right" color="black" size="lg" />,
  );
  quillIcons["list"]["ordered"] = ReactDOMServer.renderToStaticMarkup(
    <CustomIcon icon="ordered_list" color="black" size="lg" />,
  );
  quillIcons["list"]["bullet"] = ReactDOMServer.renderToStaticMarkup(
    <CustomIcon icon="unordered_list" color="black" size="lg" />,
  );
  quillIcons["bold"] = ReactDOMServer.renderToStaticMarkup(
    <CustomIcon icon="bold" color="black" size="lg" />,
  );
  quillIcons["underline"] = ReactDOMServer.renderToStaticMarkup(
    <CustomIcon icon="underline" color="black" size="lg" />,
  );
  quillIcons["italic"] = ReactDOMServer.renderToStaticMarkup(
    <CustomIcon icon="italic" color="black" size="lg" />,
  );

  return (
    <Box
      id="quill-toolbar-v2"
      sx={{
        padding: "0px !important",
        margin: "0px !important",
        border: "none !important",
        height: "32px",
      }}
    >
      <Stack
        direction={"row"}
        sx={{
          gap: "20px",
          alignItems: "center",
        }}
      >
        {/* Font size selector */}
        <Box>
          <select className="ql-size" defaultValue="">
            <option value="small">Small</option>
            <option value="">Normal</option>
            <option value="large">Large</option>
            <option value="huge">Huge</option>
          </select>
        </Box>

        <Divider orientation="vertical" flexItem />

        {/* Bold, Italic, Underline */}
        <Stack direction="row" sx={{ gap: "12px" }}>
          <button className="ql-bold" />
          <button className="ql-italic" />
          <button className="ql-underline" />
        </Stack>

        <Divider orientation="vertical" flexItem />

        {/* Align buttons */}
        <Stack direction="row" sx={{ gap: "12px" }}>
          <button className="ql-align" value="" />
          <button className="ql-align" value="center" />
          <button className="ql-align" value="right" />
        </Stack>

        <Divider orientation="vertical" flexItem />

        {/* Lists */}
        <Stack direction="row" sx={{ gap: "12px" }}>
          <button className="ql-list" value="ordered" />
          <button className="ql-list" value="bullet" />
        </Stack>
      </Stack>
    </Box>
  );
}

export default QuillToolBar;
